/**
 * Whether PGM Progress Surfaces should hide next-level purchase /
 * membership-election Apply CTAs in favor of Reapply Path Offer.
 */
export function shouldSuppressAdvancementCtas({
  standing,
  isTerminatedNoticeEnabled,
}) {
  return !!isTerminatedNoticeEnabled && !!standing?.showReapplyPathOffer
}
